import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { AssistitiApi } from "../data/apis";
import { useContext, useMemo } from "react";
import TenantContext from "../contexts/tenantContext";

export function useAssistitiContattiDataSource(assistitoId:string) {
    const api = new AssistitiApi(apiConfiguration);
    const { currentTenant } = useContext(TenantContext);

    const dataSource = useMemo(() => {   
        return new CustomStore({
          key: "id",
          loadMode: 'raw',
          load: (loadOptions) => {
            return api.getAssistitoContatti({ 
              tenantId: currentTenant.Id, 
              assistitoId: assistitoId 
            });
          },
    
          byKey: (key) => {
            return api.getAssistitoContattoById({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId,
                contattoId: key
            });
          },
    
          insert: (values) => {
            return api.insertAssistitoContatto({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId, 
                assistitoContattoCreateDTO: values
            });
          },
    
          update: (key, values) => {
            return api.updateAssistitoContatto({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId,
                contattoId: key,
                assistitoContattoUpdateDTO: values  
            });
          },
    
          remove: (key) => {
            return api.deleteAssistitoContatto({
                tenantId: currentTenant.Id,
                assistitoId: assistitoId,
                contattoId: key
            });
          }
        });
      }, [currentTenant]);
    
      return dataSource;
}


